import dayjs from "dayjs";
import { onboardingLiveTimezone } from "../onboardingLiveTime.ts";

export function formatDecimal(value: number | null): string {
  return value === null
    ? "—"
    : value.toLocaleString("it-IT", { maximumFractionDigits: 1 });
}

export function formatShare(share: number | null): string {
  return share === null ? "—" : `${Math.round(share * 100)}%`;
}

export function formatDay(dateTime: string): string {
  return dayjs(dateTime)
    .tz(onboardingLiveTimezone)
    .locale("it")
    .format("ddd D MMM");
}

export function formatFrequency(livesPerDay: number): string {
  if (livesPerDay <= 0) return "Nessuna live";
  return livesPerDay >= 1
    ? `${formatDecimal(livesPerDay)} al giorno`
    : `${formatDecimal(livesPerDay * 7)} a settimana`;
}
